/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChatEventTypeEnum } from './chatEventTypeEnum';


export interface ChatEventMessageDeliveredDto { 
    /**
     * Уникальный id события
     */
    readonly eventId: string;
    /**
     * дата создания сообщения
     */
    createdAt: number;
    /**
     * контент сообщения
     */
    textReceivedContent: any | null;
    eventType: ChatEventTypeEnum;
}
export namespace ChatEventMessageDeliveredDto {
}


